import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
const CustomModal = ({ isOpen, title, size, content, handleModalClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleModalClose}
      fullWidth={true}
      maxWidth={size}
    >
      {title ? (
        <DialogTitle id="customized-dialog-title">{title}</DialogTitle>
      ) : null}
      <DialogContent style={{}}>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModalClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
